import { createContext } from 'react'

const WidgetContext = createContext(null)

export default WidgetContext
